// Import JSON data synchronously
import enData from '@/data/leadgen/en.json';
import esData from '@/data/leadgen/es.json';
import deData from '@/data/leadgen/de.json';
import frData from '@/data/leadgen/fr.json';
import ptBrData from '@/data/leadgen/pt-br.json';
import zhHansData from '@/data/leadgen/zh-hans.json';
import thData from '@/data/leadgen/th.json';

import { LeadGenFormData } from "@/components/templates/webform/webform--lead-gen";

// Define the data object with preloaded JSON
const data: Record<string, LeadGenFormData> = {
  en: enData as unknown as LeadGenFormData,
  es: esData as unknown as LeadGenFormData,
  de: deData as unknown as LeadGenFormData,
  fr: frData as unknown as LeadGenFormData,
  'pt-br': ptBrData as unknown as LeadGenFormData,
  'zh-hans': zhHansData as unknown as LeadGenFormData,
  th: thData as unknown as LeadGenFormData,
};

/**
 * Gets leadgen data by locale synchronously.
 *
 * @param locale - The locale to fetch data for (defaults to 'en')
 * @returns LeadGenFormData - The lead generation form data for the specified locale
 */
export const getLeadGenData = (locale: string = 'en'): LeadGenFormData => {
  return data[locale] || data['en']; // Fallback to 'en' if locale doesn't exist
};